import { FileDocumentAlertIcon } from './FileDocumentAlertIcon';

/**
 * author: Simran
 * id 67AF0ACC-DE69-4E39-8226-B913764EAFE5
 * name file-document-alert
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-alert.svg
 * tags
 * - Files / Folders 
 * - Alert / Error 
 */
export const FileDocumentErrorIcon = FileDocumentAlertIcon;
export default FileDocumentErrorIcon